module.exports = __webpack_public_path__ + "static/img/watchlist.c0180e41.png";